import React,{useEffect,useState} from 'react';

import List from './channel-api-config/List'

import CreateSmsForm from './channel-api-config/sms/CreateForm'


import CreateVoiceForm from './channel-api-config/voice/CreateForm'

import EditSmsForm from './channel-api-config/sms/EditForm'
import EditVoiceForm from './channel-api-config/voice/EditForm'
import EditWhatsappForm from './channel-api-config/whatsapp/EditForm'
import EditEmailForm from './channel-api-config/email/EditForm'

import CreateWhatsAppForm from './channel-api-config/whatsapp/CreateForm'

import CreateEmailForm from './channel-api-config/email/CreateForm'


import { useLocation } from "react-router-dom";
function ChannelApiConfig(){
	const [viewPage, setViewPage] = useState('');


	const {state}  = useLocation();


	const queryParams = new URLSearchParams(window.location.search);

  const channel_id = state?.id

  const channel_name = queryParams.get('name');


	useEffect(()=>{
		getPage('list',channel_id)
	},[])

	const getPage = (pageNumber,channel_id="",rs="")=>{
		
		
		
		if(pageNumber === 'list'){
			setViewPage(<List getPage={getPage} channel_id={channel_id} channel_name={channel_name} />)
		}
		if(pageNumber === 'createSms'){
			setViewPage(<CreateSmsForm getPage={getPage} channel_id={channel_id} channel_name={channel_name} />)
		}

		if(pageNumber === 'createVoice'){
			setViewPage(<CreateVoiceForm getPage={getPage} channel_id={channel_id} channel_name={channel_name} />)
		}

		if(pageNumber === 'editSms'){
			setViewPage(<EditSmsForm getPage={getPage} rs={rs} channel_id={channel_id} channel_name={channel_name} />)
		}

		if(pageNumber === 'editVoice'){
			setViewPage(<EditVoiceForm getPage={getPage} rs={rs} channel_id={channel_id} channel_name={channel_name} />)
		}

		if(pageNumber === 'editWhatsapp'){
			setViewPage(<EditWhatsappForm getPage={getPage} rs={rs} channel_id={channel_id} channel_name={channel_name} />)
		}

		if(pageNumber === 'editEmail'){
			setViewPage(<EditEmailForm getPage={getPage} rs={rs} channel_id={channel_id} channel_name={channel_name} />)
		}

		

		if(pageNumber === 'createWhatsApp'){
			setViewPage(<CreateWhatsAppForm getPage={getPage} channel_id={channel_id} channel_name={channel_name} />)
		}

		if(pageNumber === 'createEmail'){
			setViewPage(<CreateEmailForm getPage={getPage} channel_id={channel_id} channel_name={channel_name} />)
		}



	}

	return(
		<>
			{viewPage}			
		</>
	);
}

export default ChannelApiConfig;